import { SearchQueryVariables, SearchSort } from "@/__generated__/graphql";
import { parseTagQuery } from "@/lib/normalizeHashtag";
import { ProductsCategoriesSearchParamsSchema } from "./ProductsCategoriesSearchParamsSchema";

export function getSearchQueryKey(name: string, variables: ProductsCategoriesSearchParamsSchema, slugs: string[]): any[] {
  const key = [String(name), slugs, variables.page, variables.limit, variables.sort, variables.filter ?? null, variables.search ?? null, variables.tag ?? null];

  return key;
}

export function getSearchVariables(queryParams: ProductsCategoriesSearchParamsSchema, slugs: string[]): SearchQueryVariables {
  const tags = parseTagQuery(queryParams.tag);

  return {
    limit: queryParams.limit,
    page: queryParams.page,
    filter: {
      ...queryParams.filter,
      ...(tags?.length ? { tags } : {}),
      ...(slugs && Array.isArray(slugs) && slugs.length > 0 && { categorySlugs: slugs }),
    },
    search: queryParams.search,
    sort: queryParams.sort as SearchSort,
  };
}
